__webpack_require__.p = "/reports-legacy-deactivate/referrals-hub/";